import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ReactTooltip from "react-tooltip";
import Toast from "react-bootstrap/Toast";
import axios from "axios";
import { emailValidation, emailVerifyMatch } from "./validation";
import { analytics } from "./analytics";
import { Header, Footer, DisclaimerPolicyOwner } from "./components";
import "react-datepicker/dist/react-datepicker.css";
import Enumerable from "linq";
import "react-phone-number-input/style.css";
//import PhoneInput from "react-phone-number-input";
import { getIPAddress } from "./utils/getIPAddress";

const PotentialInsuredEnroll = () => {
    //const [searchParams] = useSearchParams();
    //const payload = searchParams.get('payload');
    //const decodedPayload= JSON.parse(atob("W3sia2V5Ijoicm9sZSIsInZhbHVlIjoiY2xpZW50In0seyJrZXkiOiJjYWxsZXIiLCJ2YWx1ZSI6InBvcmNoIn0seyJrZXkiOiJyZWZlcnJlciIsInZhbHVlIjoiMTk2NzRlYjNmZDViNDVmYjhlNWQ4YzQzMGNiYjBjNDgifSx7ImtleSI6ImZpcnN0bmFtZSIsInZhbHVlIjoidGVzdENsaWVudCJ9LHsia2V5IjoibGFzdG5hbWUiLCJ2YWx1ZSI6InRlc3RDbGllbnQifSx7ImtleSI6ImVtYWlsIiwidmFsdWUiOiJhbndlc2guc2hpdmFyYW1wYWxseUBwYWNpZmljbGlmZS5jb20ifV0="));
    const searchParams = new URLSearchParams(window.location.search);
    const payload = searchParams.get("payload");
    const authentication_Code = searchParams.get("code");
    const state = searchParams.get("state");
    const DUP_EMAIL_OHH = "REGISTRATION_MSG_DUPLICATEEMAIL_WARNING";
    let decodedPayload = "";
    if (payload) {
        decodedPayload = JSON.parse(atob(payload));
    }

    const [duplicateRegistration, setDuplicateRegistration] = useState(false);
    const [user, setUser] = useState({});
    const [
        duplicateRegistrationOHHMessage,
        setDuplicateRegistrationOHHMessage
    ] = useState("");

    const insertTenant = async (tenantstate) => {
        let errMsg = "";
        try {
            const res = await axios({
                method: "PUT",
                url: `/life/enroll/api/userenroll/client/tenant/insert`,
                headers: { "content-type": "application/json" },
                data: JSON.stringify({ state: tenantstate })
            }).catch(function (err) {
                if (err.response) {
                    errMsg = err.response?.data?.error?.message;

                    console.log(
                        err.response?.data?.error?.message ||
                            err.response?.data ||
                            "Something went wrong.  Please try again later."
                    );
                    setToastMessage(
                        errMsg ||
                            "Something went wrong.  Please try again later."
                    );
                } else if (err.request) {
                    console.log(err.request);
                } else {
                    console.log("Error", err.message);
                }
            });
            console.log("insert tenant response", res);
            if (res.status === 200) {
                window.location.href = decodeURIComponent(
                    res.data.redirect_uri
                );
            }
        } catch (err) {
            throw new Error(err);
        }
    };

    const validateEnroll = async () => {
        let errMsg = "";
        const payloadObj = await getDecodedPayload(decodedPayload);
        if (
            (payloadObj.tenant.toUpperCase() == "PORCH" ||
                payloadObj.tenant.toUpperCase() == "OHH") &&
            payloadObj.email
        ) {
            try {
                const res = await axios({
                    method: "PUT",
                    url: `/life/enroll/api/userenroll/client/potential-insured/registration/validate`,
                    headers: {
                        "content-type": "application/json"
                    },
                    data: JSON.stringify({ payload: payload })
                }).catch(function (err) {
                    if (err.response) {
                        errMsg = err.response?.data?.error?.message;

                        console.log(
                            err.response?.data?.error?.message ||
                                err.response?.data ||
                                "Something went wrong. Please try again later."
                        );
                        setToastMessage(
                            errMsg ||
                                "Something went wrong.  Please try again later."
                        );
                    } else if (err.request) {
                        console.log(err.request);
                    } else {
                        console.log("Error", err.message);
                    }
                });
                console.log("insert tenant response", res);
                if (res.status === 200) {
                    if (res.data.redirect_uri) {
                        window.location.href = decodeURIComponent(
                            res.data.redirect_uri
                        );
                    } else {
                        const userObj = await getDecodedPayload(decodedPayload);
                        setUser(userObj);
                    }
                }
            } catch (err) {
                throw new Error(err);
            }
        } else {
            const userObj = await getDecodedPayload(decodedPayload);
            setUser(userObj);
        }
    };

    const getDecodedPayload = async (decodedPayload) => {
        const retObj = decodedPayload
            ? {
                  firstName: Enumerable.from(decodedPayload)
                      .where(
                          (x) => x.key == "firstname" || x.Key == "firstname"
                      )
                      .select((x) => x.value || x.Value)
                      .firstOrDefault(),
                  lastName: Enumerable.from(decodedPayload)
                      .where((x) => x.key == "lastname" || x.Key == "lastname")
                      .select((x) => x.value || x.Value)
                      .firstOrDefault(),
                  email: Enumerable.from(decodedPayload)
                      .where((x) => x.key == "email" || x.Key == "email")
                      .select((x) => x.value || x.Value)
                      .firstOrDefault(),
                  verifyEmail: Enumerable.from(decodedPayload)
                      .where((x) => x.key == "email" || x.Key == "email")
                      .select((x) => x.value || x.Value)
                      .firstOrDefault(),
                  tenant: Enumerable.from(decodedPayload)
                      .where((x) => x.key == "caller" || x.Key == "caller")
                      .select((x) => x.value || x.Value)
                      .firstOrDefault(),
                  middleName: "",
                  invitationCode: Enumerable.from(decodedPayload)
                      .where((x) => x.key == "referrer" || x.Key == "referrer")
                      .select((x) => x.value || x.Value)
                      .firstOrDefault(),
                  suffix: "",
                  id: "",
                  password: "",
                  secondaryPhoneNumber: "",
                  role: Enumerable.from(decodedPayload)
                      .where((x) => x.key == "role" || x.Key == "role")
                      .select((x) => x.value || x.Value)
                      .firstOrDefault(),
                  tenantRegistrationState: "",
                  phoneNumber: Enumerable.from(decodedPayload)
                      .where(
                          (x) =>
                              x.key == "mobile" ||
                              x.Key == "mobile" ||
                              x.key == "phone" ||
                              x.Key == "phone"
                      )
                      .select((x) => x.value || x.Value)
                      .firstOrDefault(),
                  duplicateEmail: Enumerable.from(decodedPayload)
                      .where((x) => x.key == "messages")
                      .select((x) => x.value || x.Value)
                      .firstOrDefault()
              }
            : {};

        console.log(retObj);
        return retObj;
    };

    const authorize = async () => {
        const authorizeUrl = `${decodeURIComponent(
            user.tenantRegistrationState
        )}&redirect_uri=https://${
            document.location.hostname
        }/enroll-ui/potentialinsured`;
        window.location.href = authorizeUrl;
    };
    const [errors, setErrors] = useState({
        firstName: "",
        lastName: "",
        email: "",
        verifyEmail: "",
        middleName: "",
        suffix: "",
        phoneNumber: ""
    });
    if (user.phoneNumber) {
        user.phoneNumber =
            user.phoneNumber.indexOf("+") > -1
                ? user.phoneNumber
                : `+1${user.phoneNumber}`;
    }
    const [toastMessage, setToastMessage] = useState("");
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [submitting, setsubmitting] = useState(false);

    useEffect(() => {
        validateEnroll();
        analytics();
    }, []);

    useEffect(() => {
        document.title = `Potential Insured Registration | Pacific Life`;
        if (authentication_Code && state) {
            setDuplicateRegistration(true);
            const response = insertTenant(state);
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const payload = { [name]: value };
        setUser((prev) => ({ ...prev, ...payload }));
    };

    const handleCheckboxChange = (e) => {
        const name = e.target.name;
        const value = e.target.checked;
        const payload = { [name]: value };
        setUser((prev) => ({ ...prev, ...payload }));
    };

    const handleRadioChange = async (e) => {
        const nameRd = e.target.name;
        const valueRd = e.target.value;
        const payloadRd = { [nameRd]: valueRd };
        await handleBlur(e);
        setUser((prev) => ({ ...prev, ...payloadRd }));
    };

    const handleBlur = async (e) => {
        const { name, value } = e.target;
        let errorMessage = "";

        if (name === "firstName") {
            if (value.length === 0) {
                errorMessage = "First Name must be entered";
            } else if (/[^a-zA-Z-. ]/.test(value)) {
                errorMessage =
                    "First Name must not contain spaces or numbers or special characters";
            } else {
                errorMessage = "";
            }
        }

        if (name === "lastName") {
            if (value.length === 0) {
                errorMessage = "Last Name must be entered";
            } else if (/[^a-zA-Z-. ]/.test(value)) {
                errorMessage =
                    "Last Name must not contain spaces or numbers or special characters";
            } else {
                errorMessage = "";
            }
        }

        if (name === "middleName") {
            if (/[^a-zA-Z-. ]/.test(value)) {
                errorMessage =
                    "Middle Name must not contain numbers or special characters";
            } else {
                errorMessage = "";
            }
        }

        if (name === "email") {
            if (value) {
                const emailValid = emailValidation(value);
                errorMessage = emailValid ? "" : "Enter valid email";
            } else {
                errorMessage = "Email is mandatory";
            }
        }

        if (name === "verifyEmail") {
            if (value && user.email) {
                errorMessage = emailVerifyMatch(user.email, value)
                    ? ""
                    : "Email addresses do not match";
            } else {
                errorMessage = "Confirm Email is mandatory";
            }
        }

        if (errorMessage != "") {
            setSubmitDisabled(true);
        } else {
            setSubmitDisabled(false);
        }
        setErrors((prev) => ({ ...prev, [name]: errorMessage }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let errMsg = "";
        const payload = await formatPayloadProfile();
        const testData = JSON.stringify(payload);
        setsubmitting(true);
        try {
            const res = await axios({
                method: "POST",
                url: "/life/enroll/api/userenroll/client/enroll/",
                headers: {
                    "content-type": "application/json"
                },
                data: JSON.stringify(payload)
            }).catch(function (err) {
                console.log(err.response);
                if (err.response) {
                    if (err.response.status === 421) {
                        setDuplicateRegistrationOHHMessage(
                            err.response.data.error.message
                        );
                    } else {
                        errMsg = err.response?.data?.error?.message;

                        console.log(
                            err.response?.data?.error?.message ||
                                err.response?.data ||
                                "Something went wrong.  Please try again later."
                        );
                        setToastMessage(
                            errMsg ||
                                "Something went wrong. Please try again later."
                        );
                    }
                } else if (err.request) {
                    console.log(err.request);
                } else {
                    console.log("Error", err.message);
                }
            });

            if (res.status === 200) {
                if (res.data.state) {
                    setDuplicateRegistration(true);
                    user.tenantRegistrationState = res.data.state;
                } else {
                    window.location.href =
                        "/policy-owner-login/account/reg-successful.html";
                }
            }
        } catch (error) {
            if (!duplicateRegistrationOHHMessage) {
                setToastMessage(
                    errMsg ||
                        error.response?.data?.errorMessage ||
                        "Something went wrong. Please try again later."
                );
            }
        }

        setsubmitting(false);
    };

    const formatPayloadProfile = async () => {
        return {
            id: "",
            firstName: user.firstName,
            lastName: user.lastName,
            // SSNTin: user.tin,
            secondaryPhone: user.secondaryPhoneNumber,
            //SpecialAccessXML: "",
            //CreatedBy: user.id,
            email: user.email.trim(),
            phoneNumber: user.phoneNumber,
            //UserName: user.id,
            //TrustName: user.trustName,
            userId: `${user.email.substring(
                1,
                4
            )}_${user.invitationCode.substring(1, 4)}`,
            tenant: user.tenant,
            invitationCode: user.invitationCode,
            removeEventListenerole: user.role,
            middleName: user.middleName,
            //TinType: user.tinType,
            password: user.password.trim(),
            //Policy_Number: user.policyNumber,
            ipAddress: await getIPAddress(),
            suffix: user.suffix,
            role: "client"
        };
    };

    const closeToast = () => {
        setToastMessage("");
    };

    return (
        <>
            {toastMessage !== "" && !duplicateRegistrationOHHMessage && (
                <Toast onClose={closeToast} className="toast-cont">
                    <Toast.Header>
                        <strong className="me-auto">{toastMessage}</strong>
                    </Toast.Header>
                </Toast>
            )}
            {!user.email && user.duplicateEmail !== DUP_EMAIL_OHH && (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100vw",
                        height: "100vh"
                    }}
                >
                    Loading...
                </div>
            )}
            {(user.email || user.duplicateEmail === DUP_EMAIL_OHH) && (
                <Header />
            )}

            {(user.email || user.duplicateEmail === DUP_EMAIL_OHH) &&
                !duplicateRegistration && (
                    <div className="mainMyAccount">
                        {user.duplicateEmail === DUP_EMAIL_OHH &&
                            !duplicateRegistrationOHHMessage && (
                                <div className="msg-div">
                                    The email address that you are trying to
                                    register is already associated with another
                                    user. Please register using a different
                                    email address.
                                </div>
                            )}
                        {duplicateRegistrationOHHMessage && (
                            <div
                                className="msg-div"
                                dangerouslySetInnerHTML={{
                                    __html: duplicateRegistrationOHHMessage
                                }}
                            ></div>
                        )}
                        <h1 className="heading">Register</h1>
                        <Row>
                            <Col sm={12}>
                                <label className="sub-title">
                                    Contact Information
                                </label>
                            </Col>
                        </Row>
                        <Form>
                            <Row>
                                <Col md={6}>
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control
                                        name="firstName"
                                        autoComplete="off"
                                        maxLength={25}
                                        value={user.firstName}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled="disabled"
                                    />
                                    <span className="validation-error-message">
                                        {errors.firstName}
                                    </span>
                                </Col>
                                <Col md={6}>
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control
                                        name="lastName"
                                        autoComplete="off"
                                        maxLength={35}
                                        value={user.lastName}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled="disabled"
                                    />
                                    <span className="validation-error-message">
                                        {errors.lastName}
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Label>
                                        Middle Name (Optional)
                                    </Form.Label>
                                    <Form.Control
                                        name="middleName"
                                        autoComplete="off"
                                        maxLength={25}
                                        value={user.middleName}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    />
                                    <span className="validation-error-message">
                                        {errors.middleName}
                                    </span>
                                </Col>
                                <Col md={6}>
                                    <Form.Label>Suffix (Optional)</Form.Label>
                                    <Form.Control
                                        name="suffix"
                                        autoComplete="off"
                                        maxLength={35}
                                        value={user.suffix}
                                        onChange={handleChange}
                                    />
                                    <span className="validation-error-message">
                                        {errors.suffix}
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <ReactTooltip />
                                    <Form.Label className="emailClass">
                                        Email
                                    </Form.Label>
                                    <Form.Control
                                        name="email"
                                        autoComplete="off"
                                        maxLength={60}
                                        value={user.email}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled={
                                            user.duplicateEmail == DUP_EMAIL_OHH
                                                ? false
                                                : "disabled"
                                        }
                                    />
                                    <span className="validation-error-message">
                                        {errors.email}
                                    </span>
                                </Col>
                                <Col md={6}>
                                    <Form.Label>Confirm Email</Form.Label>
                                    <Form.Control
                                        name="verifyEmail"
                                        autoComplete="off"
                                        maxLength={60}
                                        value={user.verifyEmail}
                                        onChange={handleChange}
                                        onPaste={(e) => e.preventDefault()}
                                        onBlur={handleBlur}
                                        disabled={
                                            user.duplicateEmail == DUP_EMAIL_OHH
                                                ? false
                                                : "disabled"
                                        }
                                    />
                                    <span className="validation-error-message">
                                        {errors.verifyEmail}
                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <ReactTooltip />
                                    <Form.Label className="phoneNumber">
                                        Phone Number
                                    </Form.Label>
                                    <Form.Control
                                        name="phoneNumber"
                                        value={user.phoneNumber}
                                        onChange={handleChange}
                                        //onBlur={handleBlurPhoneNumber}
                                        disabled={true}
                                    />
                                    <span className="validation-error-message">
                                        {errors.phoneNumber}
                                    </span>
                                </Col>
                            </Row>
                            <div className="buttons-myaccount">
                                <Button
                                    variant="primary"
                                    type="submit"
                                    onClick={handleSubmit}
                                    data-track="analytics"
                                    disabled={submitDisabled || submitting}
                                >
                                    {submitting ? "Registering" : "Register"}
                                </Button>
                            </div>
                        </Form>

                        <DisclaimerPolicyOwner />
                    </div>
                )}
            {user.email && duplicateRegistration && (
                <div className="mainMyAccount">
                    Our record shows you already have an existing account.
                    Please click{" "}
                    <a href="#" onClick={authorize}>
                        here
                    </a>{" "}
                    for authenticating and completing the registration.
                </div>
            )}

            <Footer />
        </>
    );
};

export default PotentialInsuredEnroll;
